module.exports = __webpack_public_path__ + "static/media/stirfry.9010a96d.png";